{
  "level": "sub00",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:sub00",
    "objects": "AREAS.E3:sub00.e3",
    "mesh": "TREES.E3:sub00.e3"
  },
  "spawn_point": {
    "position": [
      0.0,
      0.0,
      0.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      0.0,
      100.0,
      0.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      0.0,
      0.0,
      0.0
    ],
    "bbox_max": [
      0.0,
      0.0,
      0.0
    ],
    "vertex_count": 0,
    "vertices": []
  },
  "sectors": [
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 0.0,
      "bbox_min": [
        -1.0,
        -0.6000000238418579,
        0.0
      ],
      "bbox_max": [
        0.949999988079071,
        0.6499999761581421,
        0.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [],
  "tutorial_messages": []
}